package fr.frux.core.designsystem.components

import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import fr.frux.core.designsystem.theme.FruxSpacing

@Composable
fun SectionHeader(title: String, modifier: Modifier = Modifier) {
    Text(
        text = title,
        style = MaterialTheme.typography.headlineSmall,
        modifier = modifier.padding(
            start = FruxSpacing.md,
            end = FruxSpacing.md,
            top = FruxSpacing.lg,
            bottom = FruxSpacing.sm,
        ),
    )
}
